var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseTagOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00047 6.03852L8.62874 9.66732L9.66558 8.63032L6.03731 5.00152L9.66732 1.37098L8.63047 0.333984L5.00047 3.96452L1.37083 0.334357L0.333984 1.37135L3.96362 5.00152L0.335719 8.62995L1.37256 9.66695L5.00047 6.03852Z",
    fill: "var(--blue-6)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseTagOutlined);
export default __webpack_public_path__ + "static/media/closeTagOutlined.5cd1f4fcf9864d08b05789d5a9b12bad.svg";
export { ForwardRef as ReactComponent };